<mat-dialog-content class="terms-content">
  <div [innerHTML]="'dialogs.termsAndConditions.content' | translate"></div>
</mat-dialog-content>
